import { Row, Col, Input, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { disableFutureDates } from './constants';

function SeccionNotaMediaFechas({
  formik,
  yearsApi,
  handleFechaTitulos,
  userOU,
  idCedesca,
  idCntec,
}) {
  return (
    <Row className="mt-2">
      <Col md="2">
        <Label htmlFor="notaMedia">
          <small>Nota media</small>
        </Label>
        <Input
          id="notaMedia"
          name="notaMedia"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.notaMedia}
          className={formik.errors.notaMedia ? 'border border-danger error' : ''}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        />
        {formik.errors.notaMedia ? (
          <div className="text-danger tiny">{formik.errors.notaMedia}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="fechaUltimoCurso">
          <small>Fecha último curso</small>
        </Label>
        <Input
          id="fechaUltimoCurso"
          name="fechaUltimoCurso"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.fechaUltimoCurso}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        >
          {yearsApi !== ''
            ? yearsApi.map((option) => (
                <option key={`${option.Id}-fechaUltimoCurso`} value={option.Valor}>
                  {option.Valor}
                </option>
              ))
            : ''}
        </Input>
      </Col>
      <Col md="3">
        <Label htmlFor="fechaTitulo">
          <small>Fecha obtención del título</small>
        </Label>
        <DatePicker
          selected={formik.values.fechaTitulo}
          onChange={handleFechaTitulos}
          dateFormat="dd/MM/yyyy"
          locale="es"
          maxDate={new Date()}
          filterDate={disableFutureDates}
          disabled={userOU.centro === 'ORIENTACIÓN'}
          className="form-control"
          wrapperClassName="w-100"
        />
      </Col>
      <Col md="4">
        <Label htmlFor="emailCorp">
          <small>Email corporativo</small>
        </Label>
        <Input
          id="emailCorp"
          name="emailCorp"
          type="text"
          disabled={(idCedesca > 0 && idCntec > 0) || userOU.centro === 'ORIENTACIÓN'}
          onChange={formik.handleChange}
          value={formik.values.emailCorp}
        />
      </Col>
    </Row>
  );
}

SeccionNotaMediaFechas.propTypes = {
  formik: PropTypes.object.isRequired,
  yearsApi: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  handleFechaTitulos: PropTypes.func.isRequired,
  userOU: PropTypes.object.isRequired,
  idCedesca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idCntec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SeccionNotaMediaFechas;
